import { State as ConfigurationFormState } from 'contexts/ConfigurationForm/types';

const isFormChanged = (state: ConfigurationFormState): boolean => {
  // if productApiEnabled is false, we don't need to check other fields
  if (
    state.editingState.productApiEnabled === false &&
    state.currentState.productApiEnabled === false
  ) {
    return false;
  }

  if (
    state.editingState.productApiEnabled !==
    state.currentState.productApiEnabled
  ) {
    return true;
  }

  if (
    Number(state.editingState.preorderPeriod) !==
    Number(state.currentState.preorderPeriod)
  ) {
    return true;
  }

  if (
    state.editingState.regionAndLocaleSets.length !==
    state.currentState.regionAndLocaleSets.length
  ) {
    return true;
  }

  for (let i = 0; i < state.editingState.regionAndLocaleSets.length; i++) {
    const regionAndLocaleSet = state.editingState.regionAndLocaleSets[i];
    const currentRegionAndLocaleSet = state.currentState.regionAndLocaleSets[i];

    if (
      regionAndLocaleSet.region !== currentRegionAndLocaleSet.region ||
      regionAndLocaleSet.locale !== currentRegionAndLocaleSet.locale ||
      regionAndLocaleSet.enabled !== currentRegionAndLocaleSet.enabled
    ) {
      return true;
    }
  }

  return false;
};

export default isFormChanged;
